export default __webpack_public_path__ + "static/media/1759-club-logo-2-x.2e054a8c.png";